import NotificationIcon from '@tidal/toastification/components/notification-icon.vue';
import { POSITION } from 'vue-toastification';
function getNotificationContainer() {
    return document.querySelector('#global-notification-container');
}
export default (function (context, inject) {
    const customIcon = (type) => ({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        render: createElement => createElement(NotificationIcon, { props: { type } }),
    });
    const filterBeforeCreate = (toast, toasts) => {
        let delay = false;
        toasts.forEach(t => {
            if (t.type === toast.type) {
                t.eventBus?.$emit('dismiss', t.id);
                delay = true;
            }
        });
        const container = getNotificationContainer();
        if (!container) {
            return false;
        }
        if (delay) {
            container.classList.add('vue-toastifications-delay');
        }
        else {
            container.classList.remove('vue-toastifications-delay');
        }
        return toast;
    };
    const defaults = {
        closeButton: 'button',
        container: () => getNotificationContainer() || document.body,
        containerClassName: 'vue-toastifications-container',
        filterBeforeCreate,
        hideProgressBar: true,
        position: POSITION.TOP_CENTER,
        timeout: context.$config.toastification?.timeout || 10000,
        toastClassName: ['border-radius-large', 'font-size-small', 'align-center'],
        toastDefaults: {
            error: {
                icon: customIcon('error'),
            },
            info: {
                icon: customIcon('info'),
            },
            success: {
                icon: customIcon('success'),
            },
        },
        transition: 'Vue-Toastification__fadeInOut',
    };
    inject('toastDefaults', defaults);
    context.app.$toast.updateDefaults(defaults);
});
